import { useMutation } from '@tanstack/react-query';
import { findActionIn, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
export function useResetAgentPassword() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    return useMutation({
        mutationFn: async ({ agent }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findActionIn(agent.potentialAction, 'resetPassword');
            if (!action)
                throw new Error('resetPassword action unavailable for this agent');
            if (!agent.id)
                throw new Error('agent.id missing');
            const response = await invokeAction(action, user.token, {
                body: { object: agent.id },
            });
            if (!response.ok)
                throw new Error(`resetAgentPassword returned ${response.status}`);
        },
    });
}
